import { gql } from '@apollo/client';

export default gql`
  query taxCheckoutCapability($cartId: ID!) {
    taxCheckoutCapability(cartId: $cartId) {
      enabled
      reason
    }
  }
`;
